import MessageService from '../MessageService';
import SessionService from '../SessionService';
import ProxyRecorder from '../ProxyRecorder';
import { SessionState, WebCamState } from '../Enums';
import { EventEmitter } from 'events';
import { hide, UiService } from '../UiService';
import { Reasons } from '../Reasons/Reasons';
import RedirectService from '../RedirectService';
import ErrorService from '../ErrorService';

export default class WebCamAccessScreen extends EventEmitter {
    /**
     * WebCameAccessScreen constructor
     * @param {SessionService} sessionService
     * @param {MessageService} messageService
     * @param {ProxyRecorder} proxyRecorder
     * @param {UiService} uiService
     * @param {RedirectService} redirectService
     * @param {ErrorService} errorService
     */
    constructor(sessionService, messageService, proxyRecorder, uiService, redirectService, errorService) {
        super();

        this.sessionService = sessionService;
        this.messageService = messageService;
        this.proxyRecorder = proxyRecorder;
        this.uiService = uiService;
        this.redirectService = redirectService;
        this.errorService = errorService;

        this.webcamAccessTimeout = 36000;
        this.allowAccessTimeout = null;
        this.webCamAccessCallback = null;
    }

    display() {
        return new Promise((resolve) => {
            if (this.webcamAccessTimeout != 0) {
                this.allowAccessTimeout = setTimeout(this.handleWebcamAccessTimeout(resolve), this.webcamAccessTimeout * 1000);
            }

            document.getElementById('webcam-access-got-it').addEventListener('click', this.webCamAccessGotItEventHandler(resolve));

            this.uiService.switchScreen('#webcam-access');
        });
    }

    webCamAccessGotItEventHandler(displayPromiseResolve) {
        return (event) => {
            event.preventDefault();
            clearTimeout(this.allowAccessTimeout);

            hide(event.target);

            displayPromiseResolve(WebCamState.gotIt);
        };
    }

    handleWebcamAccessTimeout(displayPromiseResolve) {
        return async () => {
            const reason = Reasons.webcam_access_timeout;

            await this.sessionService.logMessage('error', reason.getUIMessage());
            await this.sessionService.changeState(SessionState.fail, reason.id, reason.getUIMessage());

            const errorMessage = this.messageService.uiMessages.webcam_access_timeout.replace('{TIMEOUT}', this.webcamAccessTimeout);
            this.errorService.displayErrorMessage(errorMessage);

            const data = {
                reason: reason.getUIMessage()
            };

            displayPromiseResolve(WebCamState.gotItTimeout, data);
        };
    }
}
